import { createSlice } from "@reduxjs/toolkit";
import { fetchCategoriesThunk } from "./categoryThunk";

const initialState = {
  categories: [],
  loading: false,
  error: null,
  showForm: false,
  linkForm: false,
  editingCategory: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setShowForm: (state, action) => {
      state.showForm = action.payload;
    },
    setLinkForm: (state, action) => {
      state.linkForm = action.payload;
    },
    setEditingCategory: (state, action) => {
      state.editingCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setShowForm,setLinkForm ,setEditingCategory } = categorySlice.actions;
export default categorySlice.reducer;
